import { Navigate, useLocation } from 'react-router-dom'
import useLogin from 'contexts/LoginContext'
import { getUserRole } from 'utils/UserAuthorization'
import ErrorBoundary from 'components/ErrorBoundary'

function PrivatePage({ Page }) {
    const { isLogged, performLogout } = useLogin()
    const location = useLocation()

    // Se está logado mas o role está vazio/inválido, força logout
    if (isLogged) {
        const userRole = getUserRole()
        if (!userRole || userRole === 'undefined') {
            performLogout()
            return <Navigate to="/login" replace />
        }
    }

    if (!isLogged)
        return <Navigate to="/login" replace />

    // Toda rota privada passa por aqui — colocar o Error Boundary neste
    // ponto único cobre o app inteiro sem precisar tocar em cada página.
    // resetKey (o caminho da URL) garante que navegar pra outra tela sai do
    // estado de erro, em vez de continuar mostrando o fallback pra sempre.
    return (
        <ErrorBoundary resetKey={location.pathname}>
            <Page />
        </ErrorBoundary>
    )
}

export default PrivatePage
